<template>
  <div
    class="roadmap-container"
    :style="{ '--roadmap-height': totalHeightVh + 'vh' }"
  >
    <div class="timelineContainer mx-auto">
      <!-- Road SVG Background -->
      <div class="road-background">
        <svg
          version="1.0"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 99.4 810.2"
          enable-background="new 0 0 99.4 810.2"
          xml:space="preserve"
          preserveAspectRatio="xMidYMin slice"
          class="road-svg"
        >
          <g>
            <path
              fill="none"
              stroke="var(--bg-main-dark)"
              stroke-width="18"
              stroke-miterlimit="10"
              d="M32.5,810.2v-54c0-27,34.5-27,34.5-54
            s-34.5-27-34.5-54v0c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54
            c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54C32.5,81,67,81,67,54
            l0,0V0"
            />
            <path
              fill="none"
              stroke="var(--text-main)"
              stroke-width="1.0"
              stroke-miterlimit="10"
              d="M77.2,54c0,18.5-11.7,27.7-21.2,35.1
            c-8.7,6.8-13.3,10.8-13.3,18.9c0,8.1,4.6,12.1,13.3,18.9c9.4,7.4,21.2,16.6,21.2,35.1c0,18.5-11.7,27.7-21.2,35.1
            c-8.7,6.8-13.3,10.8-13.3,18.9c0,8.1,4.6,12.1,13.3,18.9c9.4,7.4,21.2,16.6,21.2,35.1c0,18.5-11.7,27.7-21.2,35.1
            c-8.7,6.8-13.3,10.8-13.3,18.9s4.6,12.1,13.3,18.9c9.4,7.4,21.2,16.6,21.2,35.1s-11.7,27.7-21.2,35.1c-8.7,6.8-13.3,10.8-13.3,18.9
            c0,8.1,4.6,12.1,13.3,18.9c9.4,7.4,21.2,16.6,21.2,35.1c0,18.5-11.7,27.7-21.2,35.1c-8.7,6.8-13.3,10.8-13.3,18.9
            c0,8.1,4.6,12.1,13.3,18.9c9.4,7.4,21.2,16.6,21.2,35.1s-11.7,27.7-21.2,35.1c-8.7,6.8-13.3,10.8-13.3,18.9s4.6,12.1,13.3,18.9
            c9.4,7.4,21.2,16.6,21.2,35.1c0,18.5-11.7,27.7-21.2,35.1c-8.7,6.8-13.3,10.8-13.3,18.9v54"
            />
            <path
              fill="none"
              stroke="var(--text-main)"
              stroke-width="1.0"
              stroke-miterlimit="10"
              d="M56.7,54c0,8.1-4.6,12.1-13.3,18.9
            C34,80.3,22.2,89.5,22.2,108c0,18.5,11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9c0,8.1-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1s11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9c0,8.1-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1s11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9c0,8.1-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1c0,18.5,11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9c0,8.1-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1c0,18.5,11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9s-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1c0,18.5,11.7,27.7,21.2,35.1c8.7,6.8,13.3,10.8,13.3,18.9c0,8.1-4.6,12.1-13.3,18.9
            c-9.4,7.4-21.2,16.6-21.2,35.1v54"
            />
            <path
              fill="none"
              stroke="var(--text-main)"
              stroke-width="1.0"
              stroke-miterlimit="10"
              d="M77.2,0v54"
            />
            <path
              fill="none"
              stroke="var(--text-main)"
              stroke-width="1.0"
              stroke-miterlimit="10"
              d="M56.7,0v54"
            />
            <path
              fill="none"
              stroke="var(--text-main)"
              stroke-width="1.0"
              stroke-miterlimit="10"
              stroke-dasharray="4.581,4.581"
              d="M32.5,810.2
            v-54c0-2.2,0.4-4.6,0.4-4.6c3.6-22.6,34.1-24.1,34.1-49.5c0-27-34.5-27-34.5-54c0-27,34.5-28.6,34.5-54c0-27-34.5-27-34.5-54
            c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54
            c0-27,34.5-27,34.5-54c0-27-34.5-27-34.5-54C32.5,81,67,81,67,54v0V0"
            />
          </g>
        </svg>
      </div>

      <div class="timeline-content">
        <template
          v-for="(periodSteps, periodName, periodIndex) in groupedStepsByPeriod"
          :key="periodName"
        >
          <!-- <div
            v-if="isFirstOfNewCharacter(periodIndex)"
            class="character-header animate fadeInUp"
            :class="{ 'delay-1': periodIndex > 0 && periodSteps.length > 0 }"
            :style="getCharacterHeaderStyle(periodIndex)"
          >
            <h4 class="character-name">
              {{ extractPeriodName(periodSteps[0].period) }}
            </h4>
            <div class="character-dates">
              {{ extractPeriodDateRange(periodSteps[0].period) }}
            </div>
          </div> -->

          <div
            v-for="(step, stepIndex) in periodSteps"
            :key="step.title"
            class="timeline-item-wrapper animate"
            :style="getTimelineItemStyle(periodIndex, stepIndex)"
            :class="[
              getProjectSide(periodIndex, stepIndex) === 'right'
                ? 'item-card-on-right fadeInRight'
                : getProjectSide(periodIndex, stepIndex) === 'center'
                ? 'item-card-on-center fadeInUp'
                : 'item-card-on-left fadeInLeft',
              `delay-${getProjectNumber(periodIndex, stepIndex)}`,
            ]"
          >
            <!-- Character header for LEFT/RIGHT cards (above pin) -->
            <div
              v-if="
                stepIndex === 0 &&
                isFirstOfNewCharacter(periodIndex) &&
                !step.isCentered
              "
              class="character-header"
            >
              <h4 class="character-name">
                {{ extractPeriodName(step.period) }}
              </h4>
              <div class="character-dates">
                {{ extractPeriodDateRange(step.period) }}
              </div>
            </div>

            <div
              class="pin-container"
              :class="{ 'centered-pin': step.isCentered }"
              v-if="!step.isIntroduction"
            >
              <!-- Special 13th Pin -->
              <div
                v-if="step.isCentered && !step.isIntroduction"
                class="pin-icon special-pin-13-wrapper"
              >
                <div class="special-pin-13">13</div>
              </div>

              <!-- Standard Pin -->
              <div v-else class="pin-icon">
                <div
                  class="project-number-on-pin"
                  :style="{
                    backgroundColor: getProjectColor(
                      getProjectNumber(periodIndex, stepIndex),
                    ),
                    color: getContrastColor(
                      getProjectColor(getProjectNumber(periodIndex, stepIndex)),
                    ),
                  }"
                >
                  {{ getProjectNumber(periodIndex, stepIndex) }}
                </div>
                <svg
                  class="pin-iconSVG"
                  width="50"
                  height="60"
                  viewBox="0 0 24 24"
                  :fill="
                    getProjectColor(getProjectNumber(periodIndex, stepIndex))
                  "
                  stroke="currentColor"
                  stroke-width="1.5"
                >
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
            </div>

            <!-- Character header for CENTERED cards (between pin and card) -->
            <div
              v-if="
                stepIndex === 0 &&
                isFirstOfNewCharacter(periodIndex) &&
                step.isCentered &&
                !step.isDocumentary
              "
              class="character-header character-header-centered"
            >
              <h4 class="character-name">
                {{ extractPeriodName(step.period) }}
              </h4>
              <div class="character-dates">
                {{ extractPeriodDateRange(step.period) }}
              </div>
            </div>

            <div class="project-card">
              <div class="project-card-content">
                <div v-if="step.image" class="project-image-container">
                  <img
                    :src="step.image"
                    alt="Film image"
                    class="project-image"
                  />
                </div>
                <div class="project-text-content">
                  <small class="collection-label">
                    {{ step.collection }}
                  </small>
                  <!-- Conditional rendering for titles - Priority: Image > Special Text > Default Text -->
                  <template v-if="step.titleImage && !step.titleImageHidden">
                    <img
                      :src="step.titleImage"
                      :alt="step.titleImageAlt || step.title"
                      :class="[
                        'film-title',
                        'film-title-image',
                        step.titleImageClass,
                      ]"
                    />
                  </template>
                  <template v-else-if="step.titleClass === 'film-title-alone'">
                    <p class="film-title film-title-alone">
                      ALONE
                      <span class="wavy-word">
                        <span>w</span><span>i</span><span>t</span><span>h</span>
                      </span>
                      EVERYONE
                    </p>
                  </template>
                  <template
                    v-else-if="step.titleClass === 'film-title-sojourn'"
                  >
                    <p class="film-title film-title-sojourn">
                      THE <span class="red">Absurd</span> Sojourn
                    </p>
                  </template>
                  <template v-else>
                    <p :class="['film-title', step.titleClass]">
                      {{ step.title }}
                    </p>
                  </template>
                  <!-- Subtitle for documentary -->
                  <p v-if="step.subtitle" class="documentary-subtitle">
                    {{ step.subtitle }}
                  </p>
                  <!-- Medium + meta: special inline layout for The Child -->
                  <template v-if="isChild(step)">
                    <div class="project-tags">
                      <span class="project-medium">
                        {{ step.medium }}
                        <template v-if="step.episodes || step.duration">
                          •
                        </template>
                        <template v-if="step.episodes">{{
                          formatEpisodes(step.episodes)
                        }}</template>
                        <template v-if="step.duration">
                          <span v-if="step.episodes"> • </span
                          >{{ step.duration }}
                        </template>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="project-tags">
                      <span class="project-medium">
                        {{ step.medium }}
                      </span>
                    </div>
                    <!-- Series meta (episodes, duration) -->
                    <small
                      v-if="step.episodes || step.duration"
                      class="series-meta"
                    >
                      <template v-if="step.episodes">
                        {{ step.episodes }} episodes
                      </template>
                      <template v-if="step.duration">
                        <span v-if="step.episodes"> • </span>{{ step.duration }}
                      </template>
                    </small>
                  </template>
                  <small v-if="step.notes" class="series-meta notes">
                    {{ step.notes }}
                  </small>

                  <!-- DESCRIPTION -->
                  <p v-if="step.description" class="project-description">
                    {{ step.description }}
                  </p>

                  <!-- NEW LAUNCH TEXT -->
                  <div
                    class="row fullWidth alignBaselineRow flex-spaceBetween lastCardRow"
                  >
                    <small v-if="step.launchText" class="launch-text">
                      {{ step.launchText }}
                    </small>
                    <span
                      class="project-status"
                      :class="step.status.toLowerCase().replace(' ', '-')"
                    >
                      <svg
                        v-if="step.status === 'written'"
                        class="status-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polyline points="20,6 9,17 4,12"></polyline>
                      </svg>
                      <svg
                        v-if="step.status === 'In development'"
                        class="status-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <circle cx="12" cy="12" r="5"></circle>
                      </svg>
                      <svg
                        v-if="step.status === 'Ongoing'"
                        class="status-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 16,14"></polyline>
                      </svg>
                      {{ titleCase(step.status) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";

// Helper function for text contrast
function getContrastColor(hexColor) {
  // Guard against undefined/null
  if (!hexColor) return "white";

  // Convert hex to RGB
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? "black" : "white";
}

// Helper to get color with wrap-around for projects > 12
function getProjectColor(projectNumber) {
  if (!projectNumber || projectNumber < 1) return pastelFilmColors[0];
  const index = (projectNumber - 1) % pastelFilmColors.length;
  return pastelFilmColors[index];
}

// Pastel color sequence
const pastelFilmColors = [
  "#FFB3BA", // 1-RED (pastel)
  "#FFDFBA", // 2-ORANGE (pastel)
  "#FFFFBA", // 3-YELLOW (pastel)
  "#BAFFC9", // 4-GREEN (pastel)
  "#BAE1FF", // 5-LIGHT BLUE (pastel)
  "#B5B5FF", // 6-DARK BLUE (pastel)
  "#FFC1F3", // 7-PINK (pastel)
  "#E6C1FF", // 8-VIOLET (pastel)
  "#D8BFD8", // 9-PURPLE (pastel)
  "#FFFFFF", // 10-WHITE
  "#C0C0C0", // 11-SILVER
  "#FFECB3", // 12-GOLD (pastel)
];

export default {
  name: "FilmProjectsRoadmapPath",
  setup() {
    // Road SVG has 15 curve segments (viewBox 810.2 / 54 per curve ≈ 15)
    // We need 12 curves for films + space for intro and documentary
    const SEGMENTS = 15; // Match actual SVG curve count
    const BASE_HEIGHT = 150;
    const SCALE_FACTOR = 2.5; // Adjust overall height

    // Calculated scaled values
    const totalHeightVh = BASE_HEIGHT * SCALE_FACTOR;
    const segmentHeightVh = totalHeightVh / SEGMENTS;
    const steps = ref([
      {
        period: "FOUNDATIONAL YEARS [2026–2027]",
        collection: "",
        title: "Two Silent Years",
        medium: "Incubation · Production · Inner Architecture",
        status: "",
        titleClass: "film-title-intro",
        launchText: "",
        description: "",
        isCentered: true,
        isIntroduction: true,
        image: null,
      },
      {
        period: "CECILIA [2028-2029]",
        collection: "1. Spring Collection",
        title: "ALONE WITH EVERYONE",
        medium: "Feature film + Novella",
        status: "written",
        image: require("@/assets/images/Cecilia/ceciliafilme1/1.jpg"),
        titleClass: "film-title-alone",
        launchText: "Expected release: Spring 2028",
        description:
          "Establishes the emotional and symbolic root of the universe.",
      },
      {
        period: "CECILIA [2028-2029]",
        collection: "2. Summer Collection",
        title: "DREAMSCAPES OF NO TOMORROW",
        medium: "Feature film + Novella",
        status: "written",
        image: require("@/assets/images/Cecilia/ceciliafilme2/2.jpg"),
        titleClass: "film-title-dreamscapes",
        launchText: "Expected release: Fall/Winter 2028",
        description:
          "Innocence erupts into creative force, and the mythic language of the universe takes shape.",
      },
      {
        period: "CECILIA [2028-2029]",
        collection: "3. Fall Collection",
        title: "THE ABSURD SOJOURN",
        medium: "Non-fiction & fiction mini TV series + Short storybook",
        status: "In development",
        episodes: 7,
        duration: "40 min",
        image: require("@/assets/images/Cecilia/ceciliafilme3/1.jpg"),
        titleClass: "film-title-sojourn",
        launchText: "Expected release: Spring/Summer 2029",
        description:
          "The universe begins observing itself as identity fractures and infinite possibilities unfold.",
      },
      {
        period: "CECILIA [2028-2029]",
        collection: "4. Winter Collection",
        title: "LITTLE DEATH",
        medium: "Feature film + Immersive exhibition (mockumentary)",
        status: "In development",
        image: require("@/assets/images/Cecilia/ceciliafilme4/1.jpg"),
        titleClass: "film-title-lapetitemort",
        launchText: "Expected release: Fall/Winter 2029",
        description:
          "A public act of creative sacrifice collapses the myth, marking the universe’s first conscious rupture of identity.",
      },
      {
        period: "PATRICIA & her alter egos [2030–2033]",
        collection: "5. Spring Collection",
        title: "THE MOUNTAIN",
        titleImage: require("@/assets/images/Patricia/images/titles/the-mountain.png"),
        titleImageAlt: "The Mountain title graphic",
        medium: "Feature film + Novel",
        status: "written",
        image: require("@/assets/images/Patricia/images/1-mountain/1.jpg"),
        titleClass: "film-title-mountain",
        launchText: "Expected release: Spring 2030",
        description:
          "Authorship awakens in human form, grounding the story before it begins to fracture.",
      },
      {
        period: "PATRICIA & her alter egos [2030–2033]",
        collection: "6. Summer Collection",
        title: "MAN SHALL NEVER KNOW ANY OF THIS",
        titleImage: require("@/assets/images/Patricia/images/titles/man_2.png"),
        titleImageAlt: "Man Shall Never Know Any of This title graphic",
        medium: "Mini TV Series + Novel",
        status: "written",
        image: require("@/assets/images/Patricia/images/2-man/5.jpg"),
        episodes: 13,
        duration: "60 min",
        titleClass: "film-title-man",
        launchText: "Expected release: Summer 2031",
        description:
          "The story enters its own universe as identity splits across parallel realities, revealing the origin of separation.",
      },
      {
        period: "PATRICIA & her alter egos [2030–2033]",
        collection: "7. Fall Collection",
        title: "ECHO",
        titleImage: require("@/assets/images/Patricia/images/titles/Echo.png"),
        titleImageAlt: "Echo title graphic",
        medium: "Mockumentary Feature Film",
        status: "In development",
        image: require("@/assets/images/Patricia/images/placeholders/ech_placeholder.jpg"),
        launchText: "Expected release: Fall 2032",
        description:
          "Fractured identities echo across realities, closing karmic loops as convergence takes form.",
      },
      {
        period: "PATRICIA & her alter egos [2030–2033]",
        collection: "8. Winter Collection",
        title: "WHAT TAKES SHAPE IN THE MIDDLE OF NOWHERE",
        medium: "Feature film + Novel",
        status: "written",
        image: require("@/assets/images/Patricia/images/placeholders/whattakes_placeholder.jpg"),
        titleImage: require("@/assets/images/Patricia/images/titles/what_takes_shape.png"),
        titleImageAlt: "What Takes Shape in the Middle of Nowhere",
        launchText: "Expected release: Winter 2033",
        description:
          "The story enters the labyrinth of its own creation, preparing the transition from authorship to collective consciousness.",
      },
      {
        period: "THE PATH [2034–2037]",
        collection: "9. Spring Collection",
        title: "THE CHILD THAT CAME FROM THE EAST",
        titleImage: require("@/assets/images/Path/titles/theChild.png"),
        titleImageAlt: "The Child That Came From The East title graphic",
        titleImageClass: "film-title-thechild",
        medium: "Animation TV series + short storybook",
        status: "written",
        image: require("@/assets/images/Path/placeholders/the_child_placeholder.png"),
        episodes: 8,
        duration: "50 min",
        notes: "Includes one mixed episode (animation/film)",
        launchText: "Expected release: Spring 2034",
        description:
          "Opposites converge as the universe integrates East and West, birthing unified consciousness.",
      },
      {
        period: "THE PATH [2034–2037]",
        collection: "10. Summer Collection",
        title: "THE PATH S1",
        titleImage: require("@/assets/images/Path/titles/thepath_placeholders_title_1.jpg"),
        titleImageAlt: "The Path Season 1",
        medium: "Fiction & non-fiction hybrid TV Series + Scribe Novel",
        status: "written",
        image: require("@/assets/images/Path/placeholders/thepaths1_placeholder.png"),
        titleImageHidden: false,
        episodes: 6,
        duration: "55 min",
        launchText: "Expected release: Summer 2035",
        description:
          "The path awakens as a living initiation, transforming narrative into lived experience.",
      },
      {
        period: "THE PATH [2034–2037]",
        collection: "11. Fall Collection",
        title: "THE PATH S2",
        titleImage: require("@/assets/images/Path/titles/thepath_placeholders_title_2.jpg"),
        titleImageAlt: "The Path Season 2",
        medium: "Fiction & non-fiction hybrid TV Series + Scribe Novel",
        status: "written",
        image: require("@/assets/images/Path/placeholders/thepaths2_placeholder.jpg"),
        titleImageHidden: false,
        episodes: 6,
        duration: "55 min",
        launchText: "Expected release: Fall 2036",
        description:
          "Story and reality merge as authorship dissolves into a shared field of creation.",
      },
      {
        period: "THE PATH [2034–2037]",
        collection: "12. Winter Collection",
        title: "DEUS EX MACHINA",
        titleImage: require("@/assets/images/Path/titles/deus_ex_machina.png"),
        titleImageAlt: "Deus Ex Machina title graphic",
        medium: "Mockumentary feature film + live theatre show",
        status: "In development",
        image: require("@/assets/images/Path/placeholders/deus_placeholder.jpg"),
        launchText: "Expected release: Winter 2037",
        description:
          "Myth incarnates physically, transforming the audience into participants within the universe.",
      },
      {
        period: "",
        collection: "",
        title: "THE 13TH PIECE: A Decade of Becoming",
        subtitle: "~ the observer of the observer ~",
        medium: "Feature Documentary (Multi-year Chronicle)",
        status: "Ongoing",
        launchText: "Expected release: 2039",
        description: "The universe turns inward, observing its own becoming.",
        titleClass: "film-title-documentary",
        isCentered: true,
        isDocumentary: true,
      },
    ]);

    // Curve points for 12 films - positioned at each road curve
    // Start at segment 1.5 to give space for intro, then every segment
    const curvePoints = ref([
      { topVh: 1.5 * segmentHeightVh, cardSide: "left" }, // Film 1
      { topVh: 2.5 * segmentHeightVh, cardSide: "right" }, // Film 2
      { topVh: 3.5 * segmentHeightVh, cardSide: "left" }, // Film 3
      { topVh: 4.5 * segmentHeightVh, cardSide: "right" }, // Film 4
      { topVh: 5.5 * segmentHeightVh, cardSide: "left" }, // Film 5
      { topVh: 6.5 * segmentHeightVh, cardSide: "right" }, // Film 6
      { topVh: 7.5 * segmentHeightVh, cardSide: "left" }, // Film 7
      { topVh: 8.5 * segmentHeightVh, cardSide: "right" }, // Film 8
      { topVh: 9.5 * segmentHeightVh, cardSide: "left" }, // Film 9
      { topVh: 10.5 * segmentHeightVh, cardSide: "right" }, // Film 10
      { topVh: 11.5 * segmentHeightVh, cardSide: "left" }, // Film 11
      { topVh: 12.5 * segmentHeightVh, cardSide: "right" }, // Film 12
    ]);

    const groupedStepsByPeriod = computed(() => {
      const groups = {};
      steps.value.forEach((step) => {
        const periodName = step.period;
        if (!groups[periodName]) groups[periodName] = [];
        groups[periodName].push(step);
      });
      return groups;
    });

    const extractPeriodName = (periodText) => periodText.split("[")[0].trim();
    const extractPeriodDateRange = (periodText) => {
      const match = periodText.match(/\[(.*?)\]/);
      return match ? `[${match[1]}]` : "";
    };

    const isFirstOfNewCharacter = (periodIndex) => {
      if (
        periodIndex === 0 &&
        groupedStepsByPeriod.value[Object.keys(groupedStepsByPeriod.value)[0]]
          ?.length > 0
      )
        return true;
      if (periodIndex > 0) {
        const periodNames = Object.keys(groupedStepsByPeriod.value);
        const currentPeriodKey = periodNames[periodIndex];
        const prevPeriodKey = periodNames[periodIndex - 1];
        if (
          groupedStepsByPeriod.value[currentPeriodKey]?.length > 0 &&
          groupedStepsByPeriod.value[prevPeriodKey]?.length > 0
        ) {
          const currentCharacter = extractPeriodName(
            groupedStepsByPeriod.value[currentPeriodKey][0].period,
          );
          const previousCharacter = extractPeriodName(
            groupedStepsByPeriod.value[prevPeriodKey][0].period,
          );
          return currentCharacter !== previousCharacter;
        }
      }
      return false;
    };

    const getProjectNumber = (periodIndex, stepIndex) => {
      let number = 0; // Start at 0, intro doesn't count
      const periodNames = Object.keys(groupedStepsByPeriod.value);
      for (let i = 0; i < periodIndex; i++) {
        // Count non-intro items in previous periods
        const periodSteps = groupedStepsByPeriod.value[periodNames[i]];
        periodSteps.forEach((step) => {
          if (!step.isIntroduction) number++;
        });
      }
      // Count non-intro items in current period up to stepIndex
      const currentPeriodSteps =
        groupedStepsByPeriod.value[periodNames[periodIndex]];
      for (let j = 0; j <= stepIndex; j++) {
        if (!currentPeriodSteps[j].isIntroduction) number++;
      }
      return number;
    };

    const getProjectSide = (periodIndex, stepIndex) => {
      const periodNames = Object.keys(groupedStepsByPeriod.value);
      const step =
        groupedStepsByPeriod.value[periodNames[periodIndex]][stepIndex];
      if (step && step.isCentered) return "center";

      const projectNumber = getProjectNumber(periodIndex, stepIndex);
      // curveIndex is projectNumber - 1 (since project 1 = curve 0)
      const curveIndex = projectNumber - 1;
      if (curveIndex >= 0 && curveIndex < curvePoints.value.length) {
        return curvePoints.value[curveIndex].cardSide;
      }
      return projectNumber % 2 === 1 ? "left" : "right";
    };

    const getTimelineItemStyle = (periodIndex, stepIndex) => {
      const periodNames = Object.keys(groupedStepsByPeriod.value);
      const step =
        groupedStepsByPeriod.value[periodNames[periodIndex]][stepIndex];
      const projectNumber = getProjectNumber(periodIndex, stepIndex);

      if (step && step.isCentered) {
        if (step.isIntroduction) {
          // Intro positioned at top, before first curve
          return {
            position: "absolute",
            top: `${segmentHeightVh * 0.5}vh`,
            width: "100%",
            transform: "translateY(-50%)",
            display: "flex",
            justifyContent: "center",
            left: 0,
          };
        }

        // Documentary - positioned below the last curve point
        const lastPoint = curvePoints.value[curvePoints.value.length - 1];
        const topVh = lastPoint.topVh + segmentHeightVh * 1.5; // 1.5 segments after last film
        return {
          position: "absolute",
          top: `${topVh}vh`,
          width: "100%",
          transform: "translateY(-50%)",
          display: "flex",
          justifyContent: "center",
          left: 0,
        };
      }

      // curveIndex is projectNumber - 1 (since project 1 = curve 0)
      const curveIndex = projectNumber - 1;

      if (curveIndex >= 0 && curveIndex < curvePoints.value.length) {
        const point = curvePoints.value[curveIndex];
        return {
          position: "absolute",
          top: `${point.topVh}vh`,
          width: "100%",
          transform: "translateY(-50%)",
        };
      }
      return {};
    };

    const getCharacterHeaderStyle = (periodIndex) => {
      const periodKeys = Object.keys(groupedStepsByPeriod.value);
      if (
        periodIndex >= periodKeys.length ||
        !groupedStepsByPeriod.value[periodKeys[periodIndex]]?.[0]
      ) {
        return { display: "none" };
      }

      const projectNumberOfFirstItemInPeriod = getProjectNumber(periodIndex, 0);
      const curveIndexForFirstItem = projectNumberOfFirstItemInPeriod - 1;

      if (
        curveIndexForFirstItem >= 0 &&
        curveIndexForFirstItem < curvePoints.value.length
      ) {
        const firstItemPoint = curvePoints.value[curveIndexForFirstItem];
        const headerTopVh = firstItemPoint.topVh - segmentHeightVh * 0.82;
        return {
          position: "absolute",
          top: `${headerTopVh}vh`,
          left: "0",
          transform: "translateX(0) translateY(-50%)",
          zIndex: 10,
        };
      }
      return {
        position: "absolute",
        top: "5vh",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        zIndex: 10,
      };
    };

    const titleCase = (str) =>
      str
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");

    onMounted(() => {
      const elements = document.querySelectorAll(".animate");
      const observerOptions = {
        root: null,
        rootMargin: "-10% 0px",
        threshold: 0.1,
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      }, observerOptions);
      elements.forEach((el) => observer.observe(el));
    });

    const isChild = (step) =>
      (step.title && step.title.toLowerCase().includes("the child")) ||
      (step.titleImageAlt &&
        step.titleImageAlt.toLowerCase().includes("the child"));

    const formatEpisodes = (eps) => `${eps} ${eps === 1 ? "Ep" : "Eps"}`;

    return {
      steps,
      groupedStepsByPeriod,
      pastelFilmColors, // Use pastel colors
      getProjectColor, // Helper to get color with wrap-around
      getContrastColor, // Make contrast function available
      extractPeriodName,
      extractPeriodDateRange,
      isFirstOfNewCharacter,
      getProjectNumber,
      getProjectSide,
      getTimelineItemStyle,
      getCharacterHeaderStyle,
      titleCase,
      isChild,
      formatEpisodes,
      // Expose scaled values for template
      totalHeightVh,
    };
  },
};
</script>

<style scoped>
.roadmap-container {
  --pin-horizontal-offset: 0px; /* Pin is now centered, offset handled by card placement */
  position: relative;
  background-color: var(--bg-main-dark);
  padding: var(--doubleSpace) 0;
  min-height: var(--roadmap-height);
}

.timelineContainer {
  /* This is the .container.mx-auto */
  position: relative; /* Children are positioned relative to this */
  max-width: 900px; /* Fixed width for desktop content area */
  height: var(
    --roadmap-height
  ); /* Explicit height for vh calculations of children */
  margin: 0 auto;
}

.road-background {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%; /* Takes height of .timelineContainer */
  z-index: 1;
  pointer-events: none;
}

.road-svg {
  width: auto; /* Maintain aspect ratio */
  height: 100%; /* Stretch to fill .road-background */
  /* max-width: 120px; /* Optional: if you want to cap road visual width */
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 3%,
    rgba(0, 0, 0, 0.1) 6%,
    rgba(0, 0, 0, 0.5) 10%,
    black 15%,
    black 85%,
    rgba(0, 0, 0, 0.5) 90%,
    rgba(0, 0, 0, 0.1) 94%,
    transparent 97%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 3%,
    rgba(0, 0, 0, 0.1) 6%,
    rgba(0, 0, 0, 0.5) 10%,
    black 15%,
    black 85%,
    rgba(0, 0, 0, 0.5) 90%,
    rgba(0, 0, 0, 0.1) 94%,
    transparent 97%,
    transparent 100%
  );
}

.timeline-content {
  /* This div is now effectively the same as .timelineContainer for positioning context */
  position: relative; /* Take up full space of .timelineContainer */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.timeline-item-wrapper .character-header {
  position: absolute;
  bottom: 100%; /* cola à borda superior do cartão */
  left: 0; /* mesma coluna do cartão */
  transform: translateY(-4px); /* distância fixa de 8 px (muda se quiseres) */
  z-index: 10;
}

/* se o cartão estiver do lado direito, empurra o cabeçalho também */
.item-card-on-right .character-header {
  left: auto;
  right: 0;
}

.character-header {
  text-align: left;
  background-color: rgba(16, 16, 16, 0.95);

  border-radius: var(--border-radius-medium);
  max-width: 400px;
  width: fit-content;
  /* JS applies: position, top, left, transform, zIndex */
}
.character-name {
  font-family: "Inter", sans-serif;
  font-weight: 630;
  font-size: var(
    --regularFontSize
  ); /* Adjusted for potentially tighter space */
  /* color: var(--lazuli-300); */
  letter-spacing: 0.1em;
}
.character-dates {
  color: var(--grey-dark);
  font-size: var(--smallFontSize);
}

.timeline-item-wrapper {
  display: flex;
  align-items: center;
  margin-top: 3vh;
  /* JS applies: position, top, width, transform (translateY) */
}
.timeline-item-wrapper.item-card-on-left {
  padding-right: 50%; /* Space for pin and right side */
  justify-content: flex-start;
}
.timeline-item-wrapper.item-card-on-right {
  padding-left: 50%; /* Space for pin and left side */
  justify-content: flex-end;
}

.fadeInLeft .pin-container {
  left: 416px !important;
}

.fadeInRight .pin-container {
  left: 450px !important;
}

.lastCardRow {
  width: 172%;
}

.pin-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); /* Center the whole pin-container */
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.project-number-on-pin {
  background-color: var(--lazuli-400);
  color: var(--bg-main-dark);
  font-size: var(--smallFontSize);
  font-weight: bold;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -39px;
  z-index: 11; /* Above pin icon */
  border: 3px solid var(--bg-main-dark);
  padding: 3px;
}

.pin-icon {
  display: flex;
  flex-direction: column;
  height: 60px;
  font-weight: bold;

  border-radius: var(--border-radius-small);

  align-items: center;
  justify-content: center;
  color: var(--bg-main-dark);
  z-index: 13;
}

.project-card {
  background-color: rgb(27 27 27 / 80%);
  border-radius: var(--border-radius-medium);
  padding: var(--smallSpace);
  width: 400px; /* Max card width */
  max-width: calc(
    100% - 16px - 10px
  ); /* Half wrapper - half pin approx - gap */
  position: relative; /* For old project-number, now removed */
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 2;
  overflow: hidden;
}
.project-image-container {
  position: absolute;
  width: 40%;
  height: 100%;
  transform: translate(0, calc(var(--smallSpace) * -1));
  overflow: hidden;
  aspect-ratio: 3 / 3;
  right: 0;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.timeline-item-wrapper.item-card-on-left .project-card {
  margin-right: 10px; /* Gap from center/pin area */
}
.timeline-item-wrapper.item-card-on-right .project-card {
  margin-left: 10px; /* Gap from center/pin area */
}

/* Old .project-number is removed from card */

.collection-label {
  /* font-size: 0.9rem; */
  /* text-transform: uppercase; */
  letter-spacing: 0.05em;
  /* margin-bottom: 4px; */
  font-weight: 100;
  font-size: var(--smallerFontSize);
}

.film-title {
  margin: 6px 0;
  font-size: 1em;
}

/* Film title styles from Cecilia */
.film-title-alone {
  font-family: "AlternateGotNo2D", sans-serif;
  letter-spacing: 0.08em;
  font-size: 1.5em;
  margin: 4px 0 3px 0;
  color: #e7cf5d;
}

.film-title-dreamscapes {
  font-family: "Core Sans", sans-serif;
  font-weight: 900;
  -webkit-text-stroke: 1px var(--cecilia_dreamscapes-color-counter-color);
  text-shadow: 3px 3px var(--cecilia_dreamscapes-color-counter-color);
  font-size: 1.3em;
  margin: 3px 0 4px 0;
}

.film-title-sojourn {
  font-family: "Plinc Interlock", sans-serif;
  text-transform: uppercase;
  font-size: 1.7em;
  margin: 6px 0 6px 0;
}

.film-title-lapetitemort {
  font-family: "Biro Script Sloppy", sans-serif;
  font-size: 1.5em;
  margin: 6px 0 6px 0;
}

/* Image title styles */
/* .film-title-image {
  max-width: 50%;
  height: auto;
  display: block;
  margin: 6px 0;
} */

.film-title-image {
  max-height: 135px; /* nunca passa disto */
  width: auto; /* mantém o rácio */
  height: auto; /* idem – redundante mas explícito */
  max-width: 50%; /* continua a caber no cartão */
  display: block;
  margin: 6px 0; /* mantém o “respiro” vertical */
  object-fit: contain; /* garante que não estica */
}

/* New per-title tweaks to mirror character components */
.film-title-echo {
  font-family: "Core Sans", sans-serif;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 0.08em;
}
.film-title-nowhere {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  letter-spacing: 0.02em;
}
/* Image tint for The Child (very pale white-yellow) */
.film-title-thechild {
  filter: brightness(1.08) saturate(0.9) sepia(0.12) hue-rotate(5deg)
    drop-shadow(0 0 6px rgba(255, 255, 200, 0.35))
    drop-shadow(0 0 12px rgba(255, 255, 200, 0.25));
}
.film-title-thepaths1,
.film-title-thepaths2,
.film-title-deusex {
  /* keep default image sizing; add slight contrast for clarity */
  filter: brightness(1.02) contrast(1.02);
}

/* Special effects for titles */
.wavy-word {
  display: inline-block;
  letter-spacing: 0.09em;
}
.wavy-word span {
  display: inline-block;
}
.wavy-word span:nth-child(odd) {
  vertical-align: 0.1em;
}
.wavy-word span:nth-child(even) {
  vertical-align: 0.2em;
}
.red {
  color: red;
}
.project-tags {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: var(--smallerFontSize);
  gap: var(--smallSpace);
  position: relative;
}
.project-medium {
  color: var(--grey);
  font-style: italic;
}
.project-status {
  display: flex;
  align-items: center;
  font-size: var(--smallerFontSize);
  gap: 4px;
  color: var(--grey);
  white-space: nowrap;
  background-color: rgb(27 27 27 / 80%);
  backdrop-filter: blur(10px);
  padding: var(--tinySpace);
  border-radius: var(--border-radius-small);
  transform: translate(2px, 2px);
}
.project-status.written {
  color: var(--green);
}
.project-status.in-development {
  color: var(--grey);
}
.project-status.ongoing {
  color: var(--gold, #d4af37);
}
.status-icon {
  flex-shrink: 0;
}

/* Launch text footer styling */
.launch-text {
  display: block;
  font-size: var(--smallerFontSize);
  color: var(--grey-light);
  margin-top: var(--smallSpace);
  text-align: left;
  font-style: italic;
  padding-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.series-meta {
  display: block;
  font-size: var(--smallerFontSize);
  color: var(--grey);
  margin-top: 4px;
}
.series-meta.notes {
  color: var(--grey-light);
  font-style: italic;
}

@media (min-width: 900px) {
  .film-title {
    max-width: 50%;
  }
  .item-card-on-center .film-title {
    max-width: 100%;
  }

  /* .project-medium {
    width: 60%;
  } */
}

/* small screens */
@media (max-width: 900px) {
  .roadmap-container {
    min-height: var(--roadmap-height);
  }
  .timelineContainer {
    /* Was .container.mx-auto */
    height: auto;
    min-height: 0vh;
    border: none; /* Remove debug border */
  }
  .road-background {
    height: var(--roadmap-height); /* Will take height of its content now */
    display: none;
  }

  .character-header {
    position: relative !important;
    top: -10px !important;
    left: auto !important;
    margin: calc(var(--largeSpace) * 8) auto 0;
    width: 90%;
    max-width: 600px;
  }
  .launch-text {
    text-align: center;
  }

  .project-image-container {
    position: relative;
    width: calc(100% + calc(var(--space) * 2));
    transform: translate(calc(var(--space) * -1), calc(var(--space) * -1));
    aspect-ratio: 16 / 9;
  }

  .film-title-image {
    /* 👉 mantém-se dentro do cartão */
    max-width: 100%;
    height: 150px;
    width: auto;
    display: block;
    margin: 6px auto;
    /* 👉 assegura que não distorce se o ficheiro for “magro” ou “largo” */
    object-fit: contain;
  }

  .project-status {
    transform: none;
  }
  .timeline-item-wrapper {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: var(--largeSpace) 0;
    padding-left: 0 !important; /* Reset desktop padding */
    padding-right: 0 !important; /* Reset desktop padding */
  }
  .pin-container {
    /* Pin is part of normal flow on mobile */
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    margin-bottom: var(--smallSpace);
  }
  .pin-icon {
    position: absolute;
    height: 0px;
    top: 0px;
  }
  .pin-iconSVG {
    display: none;
  }

  .project-card {
    width: 100%;
    margin-left: auto !important; /* Center card */
    margin-right: auto !important; /* Center card */
    text-align: center;
  }
  .character-name {
    font-size: var(--regularFontSize);
  }
  .project-card {
    padding: var(--space);
    max-width: 590px;
  }
  .project-tags {
    flex-direction: row;
    align-items: center;
    gap: var(--smallSpace);
    justify-content: center;
  }

  .fadeInRight .pin-container,
  .fadeInLeft .pin-container {
    left: 0px !important;
    top: -15px;
  }

  .character-header {
    text-align: center;
  }
}

.delay-1 {
  transition-delay: 0.1s;
}
.delay-2 {
  transition-delay: 0.2s;
}
.delay-3 {
  transition-delay: 0.3s;
}
.delay-4 {
  transition-delay: 0.5s;
}
.delay-5 {
  transition-delay: 0.6s;
}
.delay-6 {
  transition-delay: 0.7s;
}
.delay-7 {
  transition-delay: 0.8s;
}
.delay-8 {
  transition-delay: 0.9s;
}
.delay-9 {
  transition-delay: 1s;
}
.delay-10 {
  transition-delay: 1.1s;
}
.delay-11 {
  transition-delay: 1.2s;
}
.delay-12 {
  transition-delay: 1.3s;
}

/* Centered Item Styles */
.timeline-item-wrapper.item-card-on-center {
  padding: 0;
  justify-content: center;
  flex-direction: column;
}

.centered-pin {
  position: relative;
  left: auto !important;
  top: auto !important;
  transform: none !important;
}

.special-pin-13-wrapper {
  height: auto; /* Override fixed height */
}

.special-pin-13 {
  margin-bottom: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(200, 200, 255, 1);
  color: var(--bg-main-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 0 20px 5px rgba(255, 255, 255, 0.3),
    0 0 40px 10px rgba(100, 149, 237, 0.2); /* Aura/Glow */
  border: 3px solid var(--bg-main-dark);
  font-family: "Inter", sans-serif;
  z-index: 20;
}

/* Text content must not overlap image container (40% width on right) */
.project-text-content {
  width: 58%; /* Leave room for image (40%) + small gap */
  max-width: 58%;
}

/* When no image, text can use full width */
.project-card:not(:has(.project-image-container)) .project-text-content {
  width: 100%;
  max-width: 100%;
}

.project-description {
  font-size: 0.85rem;
  color: var(--grey-light);
  margin: 8px 0;
  line-height: 1.4;
  font-style: italic;
  font-family: "Georgia", serif; /* Serif for descriptions/narrative */
}

/* Centered card character-header placement - between pin and card */
.item-card-on-center .character-header,
.character-header-centered {
  position: relative;
  bottom: auto;
  left: auto;
  margin: 12px auto;
  text-align: center;
}

.item-card-on-center .character-name,
.item-card-on-center .character-dates,
.character-header-centered .character-name,
.character-header-centered .character-dates {
  text-align: center;
}

/* Intro and documentary cards use default .film-title styling */
.film-title-intro,
.film-title-documentary {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 1em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-main);
  margin: 6px 0;
}

/* Documentary subtitle */
.documentary-subtitle {
  font-family: "Cormorant Garamond", Georgia, serif;
  font-style: italic;
  font-size: 0.95em;
  color: var(--grey-light);
  margin: 4px 0 12px 0;
}

/* Centered cards (intro and documentary) - proper card styling */
.item-card-on-center .project-card {
  background-color: rgb(27 27 27 / 80%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: var(--smallSpace);
  max-width: 400px;
  text-align: center;
}

.item-card-on-center .project-text-content {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.item-card-on-center .project-tags {
  justify-content: center;
  width: 100%;
}

.item-card-on-center .project-medium {
  font-size: 0.8rem;
  color: var(--grey);
  text-align: center;
}

.item-card-on-center .collection-label {
  text-align: center;
}

.item-card-on-center .film-title {
  text-align: center;
  width: 100%;
}

.item-card-on-center .project-description {
  text-align: center;
}

.item-card-on-center .launch-text {
  text-align: center;
  border-top: none;
}

.item-card-on-center .row {
  justify-content: center;
}

.item-card-on-center .project-status {
  position: static;
}
</style>
